import { post } from '../api';
import { refreshMe } from '../session';
import { Button, Card, navigate, toast, useAction } from '../ui';

/** Development stand-in for the hosted checkout page (only enabled with DEV_BILLING). */
export function Simulate(p: { token: string }) {
	let summary = '';
	try {
		const body = JSON.parse(atob(p.token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/')));
		const x = body.p;
		summary = `${x.kind}${x.plan ? ` — ${x.plan}${x.interval === 'year' ? ' (yearly)' : ''}` : ''} for $${(x.amountCents / 100).toFixed(2)}`;
	} catch {
		summary = 'Unknown purchase';
	}
	const [pay, busy] = useAction(async () => {
		await post('/api/billing/simulate', { token: p.token });
		await refreshMe();
		toast('Payment simulated.', 'ok');
		navigate('/account');
	});
	return (
		<main class="page narrow">
			<Card title="Test checkout">
				<p>This development server simulates payments (no Helcim token configured). No money moves.</p>
				<p>
					<strong>{summary}</strong>
				</p>
				<div class="row">
					<Button onClick={() => pay()} busy={busy}>
						Complete test payment
					</Button>
					<Button variant="ghost" onClick={() => navigate('/account')}>
						Cancel
					</Button>
				</div>
			</Card>
		</main>
	);
}
